import { render, staticRenderFns } from "./editor-panel-styles.vue?vue&type=template&id=4c567cc2"
import script from "./editor-panel-styles.vue?vue&type=script&lang=js"
export * from "./editor-panel-styles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports